let resumeData = {
    "name": "Uladzimir Treihis",
    "role": "Web Developer and Data Scientist",
    "roleDescription": "I am a solution-oriented enthusiast (nerd), tutor, learner, programmer and mathematician",
    "socialLinks":[
        {
          "name":"linkedin",
          "url":"https://www.linkedin.com/in/uladzimir-treihis/",
          "className":"fa fa-linkedin"
        },
        {
          "name":"github",
          "url":"https://github.com/UladzimirTreihis",
          "className":"fa fa-github"
        },
        {
          "name":"email",
          "url":"mailto:uladzimir.treihis@gmail.com",
          "className":"fa fa-envelope"
        }
      ],
    "aboutMe": "I'm a passionate problem-solver with a background in mathematics and computer science, drawn to projects that bridge technology and real-world applications. My journey has taken me around the globe—Belarus, Armenia, Singapore, Chile, and Poland—where I studied and worked, from developing educational courses to building websites and analyzing data. My personal favorite quality is critical thinking and the ability to bring new and creative solutions to the table. Beyond that, I am a functional programming and mathematics enthusiast, a sound and music designer, and a big-time geography fan.",
    "basedIn":"Malmö, Sweden | Warsaw, Poland",
    "website":"https://treihis.com/",
    "education":[
      {
        "universityName":"Yale-NUS College, Singapore",
        "specialization":"Mathematical, Computational and Statistical Sciences",
        "monthFrom":"August",
        "yearFrom":"2020",
        "monthTo":"December",
        "yearTo":"2024",
        "achievements":"",
        "gpa": "4.73/5",
        "images": ["images/education/ync/0.jpg", "images/education/ync/1.jpg", "images/education/ync/2.jpg"],
        "about": "First and foremost, I have learned to learn!",
        "courses": ["Functional Programming and Proving", "Signal Processing", "Probability", "Programming for Data Science", "Introduction to Computer Science",
          "Statistical Inference", "Linear Algebra", "Generalized Linear Models", "Modern Algebra", "Real Analysis"],
        "clubs": ["YNC Technology", "Volleyball", "Ping pong", "Visual Arts Society"]
      },
      {
        "universityName":"Pontificia Universidad Catolica de Chile",
        "specialization":"Software Architecture",
        "monthFrom":"August",
        "yearFrom":"2024",
        "monthTo":"December",
        "yearTo":"2024",
        "achievements":"",
        "gpa": "",
        "images": ["images/education/uc/0.jpg", "images/education/uc/1.jpg"],
        "about": "My truly advanterous exchange program",
        "courses": ["Software Architecture", "Einstein Relativism"],
        "clubs": ["Quechua Culture and Language"]
      },
    ],
    "work":[
      {
        "companyName":"Zusia.pl",
        "role":"Software and AI Developer, Founder",
        "monthFrom":"August",
        "yearFrom":"2026",
        "monthTo":"Present",
        "yearTo":"",
        "images": ["images/experience/team.jpg", "images/portfolio/zus0.png", "images/portfolio/zus1.png", "images/portfolio/zus2.jpg"],
        "about": "A startup that provides AI-powered tax assistance to Polish entrepreneurs",
        "skills": ["Next.js", "FastAPI", "RAG", "Automation", "Semi-Agentic AI", "PostgreSQL", "Docker"],
        "achievements": [
          "Conducted market research and analysis to identify the needs and pain points of Polish entrepreneurs.",
          "Created a knowledge system based on credible legal resources",
          "Implemented an AI assistant around that knowledge base",
          "Managed the project's work in a team of 3"
        ]
      },
      {
        "companyName":"KeyTech Solutions",
        "role":"Full Stack Developer",
        "monthFrom":"July",
        "yearFrom":"2025",
        "monthTo":"June",
        "yearTo":"2026",
        "images": ["images/experience/fullstack2.png", "images/experience/fullstack0.jpg", "images/experience/fullstack01.png"],
        "about": "Full Stack Developer at a contract work for a startup in the advertising industry",
        "skills": ["Next.js", "React", "Node.js", "MUI", "Integrations", "REST APIs", "PostgreSQL"],
        "achievements": [
          "Engineered API and components for the dashboard interface of advertisements improving clients UX and KPI visibility.",
          "Built a reporting API that automated the generation and delivery of PDF reports via Slack and SendGrid, replacing a manual process and providing on-demand insights for the sales team.",
          "Refactored the primary ad-filtering system from single-select to a multi-filter component, improving user experience and enabling more complex ad campaign analysis."
        ]
      },
      {
        "companyName":"Foreo",
        "role":"AI Developer, Intern Team Leader",
        "monthFrom":"March",
        "yearFrom":"2025",
        "monthTo":"July",
        "yearTo":"2025",
        "images": ["images/experience/foreo0.png", "images/experience/foreo1.png"],
        "about": "Leading a team of interns to develop different AI solutions for the skin care industry",
        "skills": ["GKE", "Python", "RAG", "Transformers"],
        "achievements": [
          "Designed, implemented and deployed a RAG-based Chatbot to Foreo’s web-services to increase sales.",
          "Managed Foreo’s GCP account, setting up the documentation and standards across several projects.",
          "Consulted the company on the best AI solutions in terms of resources and efficiency.",
          "Managed a team of 15 interns, assigning the tasks, integrating their solutions and providing the feedback based on the company's immidiate needs."
        ]
      },
      {
        "companyName":"Crimson Education",
        "role":"Web Development and AITutor",
        "monthFrom":"August",
        "yearFrom":"2024",
        "monthTo":"December",
        "yearTo":"2024",
        "images": ["images/experience/crimson0.png", "images/experience/crimson1.png"],
        "about": "Leading the high school students from the absolute beginners to their full stack applications",
        "skills": ["React", "Node.js", "Flask", "SQL", "SQLite"],
        "achievements": [
          "Designed new Frontend with React and Backend with Flask courses expanding the school to Web -Development.",
          "Mentored over 20 students from absolute beginners to their first hosted web-projects using FastAPI, Node and React."
        ]
      },
      {
        "companyName":"Yale-NUS Research",
        "role":"Web Developer",
        "monthFrom":"May",
        "yearFrom":"2021",
        "monthTo":"November",
        "yearTo":"2022",
        "images": ["images/experience/yncit0.jpeg", "images/experience/yncastro1.png"],
        "about": "Building a web service for the leading data collection and processing the detections of atomic and molecular spectral lines for galaxies",
        "skills": ["Flask", "SQL", "GitHub", "Git", "Code review", "Presentation"],
        "achievements": [
          "Developed and architected the first web application to store, process, and visualize astrophysical data on molecular line detections of galaxies.",
          "Built a Flask-based application with user authentication and admin authorization to securely submit, parse, approve and process data from a web-form or file submission.",
          "Managed project's GitHub repository and documentation."
        ]
      },
      {
        "companyName":"Yale-NUS IT",
        "role":"Senior Student Associate",
        "monthFrom":"October",
        "yearFrom":"2020",
        "monthTo":"June",
        "yearTo":"2024",
        "images": ["images/experience/yncit0.jpeg", "images/experience/yncit1.png"],
        "about": "Helping the Yale-NUS community with IT-related issues",
        "skills": ["Communication", "Salesforce", "Reporting", "Troubleshooting"],
        "achievements": [
          "Consulted users of Yale-NUS IT resources on more than 1000 IT-related incidents in person and via Salesforce platform.",
          "Collaborated with the IT center members for creating user friendly guides and follow-up reports."
        ]
      },
      {
        "companyName":"UWC Belarus National Committee",
        "role":"Selection and Promotion Coordinator, Website Editor",
        "monthFrom":"July",
        "yearFrom":"2021",
        "monthTo":"July",
        "yearTo":"2023",
        "images": ["images/experience/uwc0.png", "images/experience/uwc1.png"],
        "about": "Promoting and making available quality education to Belarusian youth",
        "skills": ["Communication", "Canva", "SurveyMonkey", "Leadership"],
        "achievements": [
          "Prepared data analysis reports based on the selection process and participants’ data according to the Data Protection Policy.",
          "Led the promotion campaign yielding the highest number of applicants in 25 years with 100% increase from previous year."
        ]
      }
    ],
    "skillsDescription":"Skills and Tools",
    "skills": {
      "pLanguages": [
        {
          "pLanguageName":"Python",
          "level": "5"
        },
        {
          "pLanguageName":"Javascript",
          "level": "4.5"
        },
        {
          "pLanguageName":"TypeScript",
          "level": "4.5"
        },
        {
          "pLanguageName":"SQL",
          "level": "4.5"
        },
        {
          "pLanguageName":"OCaml",
          "level": "4"
        },
        {
          "pLanguageName":"R",
          "level": "3"
        },
        {
          "pLanguageName":"C",
          "level": "2"
        },
      ],
      "tools": [
        {
          "toolName": "React",
          "level": "5"
        },
        {
          "toolName": "Flask",
          "level": "5"
        },
        {
          "toolName": "Node.js",
          "level": "4.5"
        },
        {
          "toolName": "GitHub",
          "level": "4.5"
        },
        {
          "toolName": "Git",
          "level": "4.5"
        },
        {
          "toolName": "SQLite",
          "level": "4"
        },
        {
          "toolName": "PostgreSQL",
          "level": "4"
        },
        {
          "toolName": "EC 2",
          "level": "4"
        },
        {
          "toolName": "Docker",
          "level": "4"
        },
        {
          "toolName": "Coq Proof Assistant",
          "level": "4"
        },
        {
          "toolName": "Pandas",
          "level": "4"
        },
        {
          "toolName": "RAG",
          "level": "4"
        },
        {
          "toolName": "GCP",
          "level": "4"
        },
        {
          "toolName": "PyTorch",
          "level": "3.5"
        },
        {
          "toolName": "AWS Lambda",
          "level": "3"
        }
      ],
      "languages": [
        {
          "language": "English",
          "level": "5"
        },
        {
          "language": "Belarusian",
          "level": "5"
        },
        {
          "language": "Russian",
          "level": "5"
        },
        {
          "language": "Polish",
          "level": "4.5"
        },
        {
          "language": "Spanish",
          "level": "4"
        },
        {
          "language": "Ukrainian",
          "level": "3.5"
        },
      ]
    },
    "portfolio":[
      {
        "name":"Zusia.pl",
        "description":"AI Tax Assistant for Polish interpreneurs",
        "images":["images/portfolio/zus0.png", "images/portfolio/zus1.png", "images/portfolio/zus2.jpg"],
        "url": "https://zusia.pl/",
        "stack": ["Next.js", "PostgreSQL", "FastAPI", "RAG", "Retrieval Architecture"],
      },
      {
        "name":"Get Quiz AI (taken down)",
        "description":"Get your quiz based on your study materials",
        "images":["images/portfolio/quiz0.png", "images/portfolio/quiz1.png"],
        "url": "",
        "stack": ["Next.js", "MongoDB", "Revideo", "AWS Lambda"],
      },
      {
        "name":"Walacugi Tourism",
        "description":"Walacugi Tourism platform to manage the news and events (in progress)",
        "images":["images/portfolio/walacugi0.png", "images/portfolio/walacugi1.png"],
        "url": "https://walacugi.org/",
        "gitUrl": "https://github.com/UladzimirTreihis/walacugi",
        "stack": ["React", "Express.js", "Mongo", "MUI"]
      },
      {
        "name":"Foreo Assistant",
        "description":"Rag based chatbot implemented by me as part of my time at Foreo",
        "images":["images/portfolio/foreo0.png", "images/portfolio/foreo1.png"],
        "url": "https://chat.foreo.com/",
        "stack": ["React", "FastAPI", "RAG", "FAISS", "Kubernetes", "Docker", "GCP", "AWS EC2"],
      },
      {
        "name":"CoolGoat Football Bets",
        "description":"Website to track football matches and purchase bonds",
        "images":["images/portfolio/football_bets0.png", "images/portfolio/football_bets1.png", "images/portfolio/football_bets2.png", "images/portfolio/football_bets3.jpg"],
        "url": "https://github.com/UladzimirTreihis/CoolGoat",
        "stack": ["React", "Express.js", "PostgreSQL", "Docker", "Nginx", "AWS EC2", "AWS S3", "AWS Lambda", "AWS API Gateway", "Cloudfront", "MQTT"],
        "gitUrl": "https://github.com/UladzimirTreihis/CoolGoat"
      },
      {
        "name":"LineDB",
        "description":"A public database of all published detections of atomic and molecular spectral lines for galaxies at z > 1",
        "images":["images/portfolio/linedb0.png", "images/portfolio/linedb1.png"],
        "url": "https://linedb.nfshost.com/home",
        "stack": ["Flask", "SQLite", "NFShost"],
        "gitUrl": "https://github.com/UladzimirTreihis/spectral_line_detection_database"
      },
      {
        "name":"This website",
        "description":"Personal website",
        "images":["images/portfolio/website0.png"],
        "url": "https://treihis.com/",
        "stack": ["React", "MUI"],
      },
      {
        "name":"Days until I see you",
        "description":"Telegram Bot for events count down and GPT supported conversations in the context of FAISS",
        "images":["images/portfolio/telegram0.png", "images/portfolio/telegram1.png"],
        "url": "https://github.com/UladzimirTreihis/ldr_bot",
        "stack": ["Python", "FastAPI", "Telegram API"],
        "gitUrl": "https://github.com/UladzimirTreihis/ldr_bot"
      },
      {
        "name":"Google Scholar Parser",
        "description":"Parses Google Scholar for publications, authors and citations",
        "images":["images/portfolio/scholar0.jpg"],
        "stack": ["Python", "Selenium"],
        "gitUrl": "https://github.com/UladzimirTreihis/g-scholar-parser"
      },
    ],
    "map": {
      "visited": [
        "Armenia",
        "Cambodia",
        "China",
        "Georgia",
        "Malaysia",
        "Russia",
        "Singapore",
        "Turkey",
        "Vietnam",
        "Albania",
        "Austria",
        "Belarus",
        "Bulgaria",
        "Czech Republic",
        "Germany",
        "Greece",
        "Hungary",
        "Italy",
        "Latvia",
        "Lithuania",
        "Netherlands",
        "Norway",
        "Poland",
        "Portugal",
        "Slovakia",
        "Spain",
        "Sweden",
        "Ukraine",
        "Vatican City",
        "Canada",
        "Costa Rica",
        "El Salvador",
        "Guatemala",
        "Honduras",
        "Nicaragua",
        "USA",
        "Argentina",
        "Brazil",
        "Chile",
        "Peru",
        "UK"
      ],
      "lived": [
        "Belarus",
        "Singapore",
        "Chile",
        "Poland",
        "Armenia",
        "Spain",
        "USA",
        "Sweden"
      ]
    },
  }
  
  export default resumeData